import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Collapse, Table } from "reactstrap";
import StripeElementAddCard from "../../../components/billing/StripeElementAddCard";
import Loader from "../../../components/display/Loader";
import PolyUtil from "../../../util/PolyUtil";
import { handleAddCard } from "../actions/billing";


class PaymentInfo extends Component {
    state = {
        isAdding: false
    };

    toggleIsAdding = () => {
        this.setState({isAdding: !this.state.isAdding});
    };

    onSubmit = (token) => {
        // this.props._handleAddCard(token.id).then(() => this.setState({isAdding: false}));
        this.setState({isAdding: false});
    };

    render() {
        const {status, payment_method, stripe_details} = this.props;
        return (

                <Card className="pr-card">
                    <CardHeader tag="h4">Payment Information</CardHeader>
                    <Loader spin isLoading={PolyUtil.objEmpty(status) || PolyUtil.objEmpty(stripe_details)}>
                    <CardBody>
                        <p className="mb-2"><strong>Applying to listings outside of PolyRents is way too expensive</strong> -- no one should be paying hundreds of dollars in application fees (around
                            $30 - $80 per listing). <strong>We're changing that.</strong></p>
                        <p className="mb-2">With PolyRents, you pay only <strong>$40</strong> for <strong>unlimited applications</strong> for an <strong>entire month</strong>. We've heard from
                            hundreds of tenants just like you and decided to work with TransUnion to make this a reality (TransUnion is our screening partner, who we pay to get your credit reports and
                            background checks).</p>
                        <p className="mb-4">To make this even more of a sweet deal, <strong>this is not a subscription</strong>. We only charge you when you're applying to listings, so you don't have
                            to worry about paying for a service you're not actively using.</p>
                        {
                            !!payment_method && status.payment_method_on_file ? (
                                <div>
                                    <h4>Current Card:</h4>
                                    <Table responsive>
                                        <tbody>
                                        <tr>
                                            <th scope="row">Name:</th>
                                            <td>{payment_method.name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Number:</th>
                                            <td>{payment_method.brand + '  ************' + payment_method.last4}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Expires:</th>
                                            <td>{payment_method.exp_month + '/' + payment_method.exp_year}</td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            ) : (
                                <div>
                                    <h5 className="text-warning">
                                        <i className="fa fa-exclamation-triangle"/> Looks like you don't have a card on file yet. We suggest you take care of that now so that you'll be all set when
                                        listing alerts start rolling in.
                                    </h5>
                                </div>
                            )
                        }
                        {
                            !this.state.isAdding && (
                                <div className="center">
                                    <Button color="primary" className="mt-2 mb-2" style={{width: '60%'}}
                                            onClick={this.toggleIsAdding}>{status.payment_method_on_file ? 'Edit Card' : 'Add Card'}</Button>
                                </div>
                            )
                        }
                        <Collapse isOpen={this.state.isAdding}>
                            <StripeElementAddCard onSubmit={this.onSubmit} onCancel={this.toggleIsAdding}/>
                        </Collapse>
                        <p className="text-muted text-center">
                            <small>
                                <i className="fa fa-lock"/> All payment-related transactions are performed through <a href="https://stripe.com/">Stripe</a>. PolyRents does not store your card
                                details.
                            </small>
                        </p>
                    </CardBody>
                    </Loader>
                </Card>
        );
    }
}

const mapStateToProps = (state) => ({
    status: state.tenant.billing.status,
    payment_method: state.tenant.billing.payment_method,
    stripe_details: state.tenant.billing.stripe_details,
});

const mapDispatchToProps = (dispatch) => ({
    _handleAddCard(token) {
        return dispatch(handleAddCard(token));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInfo);



// WEBPACK FOOTER //
// ./src/containers/tenant/billing/PaymentMethod.js